
import gql from 'graphql-tag';

const UPDATE_LEAD_NOTE = gql` 
  mutation updateLeadNote($input: LeadNoteUpdateInput!) {
    updateLeadNote(input: $input) {
      message
      code
      data
    }
  }
`;

export default UPDATE_LEAD_NOTE;
